import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-slider-item',
  template: '<ng-content />',
  styleUrls: ['slider-item.component.scss']
})
export class SliderItemComponent {
}
